export default __webpack_public_path__ + "static/media/refectori-espleni-05.c421bd8c.jpg";